var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDealer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "980.000000pt",
    height: "910.000000pt",
    viewBox: "0 0 980.000000 910.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,910.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350 4900 l0 -4200 -175 0 -175 0 0 -350 0 -350 4900 0 4900 0 0 350 0 350 -175 0 -175 0 0 3150 0 3150 -1400 0 -1400 0 0 1050 0 1050 -3150 0 -3150 0 0 -4200z m5600 -350 l0 -3850 -2450 0 -2450 0 0 3850 0 3850 2450 0 2450 0 0 -3850z m2800 -1050 l0 -2800 -1050 0 -1050 0 0 2800 0 2800 1050 0 1050 0 0 -2800z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750 6825 l0 -525 700 0 700 0 0 525 0 525 -700 0 -700 0 0 -525z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3850 6825 l0 -525 700 0 700 0 0 525 0 525 -700 0 -700 0 0 -525z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750 5075 l0 -525 700 0 700 0 0 525 0 525 -700 0 -700 0 0 -525z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3850 5075 l0 -525 700 0 700 0 0 525 0 525 -700 0 -700 0 0 -525z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750 3325 l0 -525 700 0 700 0 0 525 0 525 -700 0 -700 0 0 -525z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3850 3325 l0 -525 700 0 700 0 0 525 0 525 -700 0 -700 0 0 -525z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7350 5075 l0 -525 350 0 350 0 0 525 0 525 -350 0 -350 0 0 -525z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7350 3325 l0 -525 350 0 350 0 0 525 0 525 -350 0 -350 0 0 -525z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealer);
export default __webpack_public_path__ + "static/media/dealer.bc406199e53570e4d984125bebbb1271.svg";
export { ForwardRef as ReactComponent };